export default __webpack_public_path__ + "assets/models/33841c1b417660d2f7893cb3115d56a4.glb";